// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"ef465f55","430":"9ae5f923","462":"807259f2","867":"4edd0468","922":"8b0d491e"}[chunkId] + ".chunk.js";
};